import React from 'react'
import { labels } from '../../../../escalas/efectos_emt/efectos_emt_catalog'

export default function EfectosEMTResults({ efectos }) {

    const RESPONSES = ["No","No estoy seguro(a)","Sí"]
    return (
        <div>
            {/* {JSON.stringify(efectos)} */}
            {
                labels.map((label, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{label}</td>
                        <td>{RESPONSES[efectos[index]]}</td>
                    </tr>
                ))
            }
        </div>
    )
}
